/* eslint-disable no-unused-vars */
import React from "react";
import { Text } from "@chakra-ui/react";

import { ModalDrawer } from "../ModalDrawer";

// components
import TermsAndCondition from "./components/TermsAndCondition";
import WalletList from "./components/WalletList";

interface WalletMenuType {
  isOpen: boolean;
  termsPageLink: string;
  connectorsList: Array<string>;
  closeModal(): void;
  onTermsLinkClick(): void;
  onTermsSelectChange(isChecked: boolean): void;
  onConnectWallet(id: string): void;
}

const WalletConnectModal: React.FC<WalletMenuType> = ({
  isOpen,
  termsPageLink,
  connectorsList,
  closeModal,
  onTermsLinkClick,
  onConnectWallet,
}) => {
  const handleClose = () => {
    closeModal();
  };

  return (
    <ModalDrawer
      isOpen={isOpen}
      closeAlert={handleClose}
      bodyProps={{ mt: "2rem" }}
      header={<Text width="100%">Connect wallet</Text>}
      contentProps={{ p: { base: "2.5rem 1rem 1rem", md: "2.5rem 3rem" } }}
      headerProps={{
        p: "0",
        fontSize: "1.5rem",
        fontWeight: "600",
        textAlign: "center",
      }}
    >
      <>
        <TermsAndCondition
          termsPageLink={termsPageLink}
          onTermsLinkClick={onTermsLinkClick}
        />
        <WalletList
          isChecked={true}
          fullWidth
          prefix="Continue with "
          onConnectWallet={onConnectWallet}
          connectorsList={connectorsList}
        />
      </>
    </ModalDrawer>
  );
};

export default WalletConnectModal;
